// extracted by mini-css-extract-plugin
module.exports = {"oneBoxStyle":"style_oneBoxStyle__kXC2h","animation":"style_animation__TT8gB"};